import { service } from ".";

export default {
  getAll: () => service.get("/projects"),
  getOne: (id) => service.get(`/projects/${id}`),
  getAllPaginate: (query) => service.get(`/projects/paginate?${query}`),
  create: (data) => service.post("/projects", data),
  update: (id, data) => service.put(`/projects/${id}`, data),
  delete: (id) => service.delete(`/projects/${id}`),
};
